module.exports = __webpack_public_path__ + "static/media/cs.b5329781.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/flags/rect/cs.svg
 ** module id = 1244
 ** module chunks = 0
 **/